import * as Yup from "yup";
import { TextField, GroupSelect, DateTimePicker } from "../../../../common/components/formFields";

export function formFields(t, sensorOptions) {
  return [
    {
      size: 12,
      field: <GroupSelect id="sensorId" label={t("schedules.QuickSchedule.form.sensor")} options={sensorOptions} required/>,
    },
    {
      size: 12,
      field: (
        <DateTimePicker
          id="startDate"
          label={t("schedules.QuickSchedule.form.startDate")}
          required
        />
      ),
    },
    {
      size: 12,
      field: <TextField id="duration" type="number" label={t("schedules.QuickSchedule.form.duration")} required />,
    },
  ];
}

export function formSchema(t) {
  return Yup.object().shape({
    sensorId: Yup.string().required(t("schedules.QuickSchedule.form.requiredSensor")),
    startDate: Yup.string().required(t("schedules.QuickSchedule.form.requiredStartDate")),
    duration: Yup.number().required(t("schedules.QuickSchedule.form.requiredDuration")),
  });
}
